import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/programa';
type CTAButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  pulse?: boolean;
  className?: string;
};
export function CTAButton({
  children,
  variant = 'primary',
  pulse = false,
  className = ''
}: CTAButtonProps) {
  const base = 'group inline-flex h-14 w-full items-center justify-center gap-3 rounded-lg px-7 text-[15px] font-bold uppercase leading-tight tracking-[0.05em] transition-[box-shadow,background-color,border-color] duration-200 ease-smooth sm:text-[17px]';
  const styles = variant === 'primary' ? 'bg-gold text-ink shadow-[0_0_18px_rgba(255,159,28,0.35),0_0_48px_rgba(255,159,28,0.28)] hover:bg-gold-warm hover:shadow-[0_0_22px_rgba(255,159,28,0.45),0_0_60px_rgba(255,159,28,0.32)]' : 'border border-gold/40 bg-transparent text-gold shadow-[0_0_30px_rgba(255,159,28,0.16)] hover:border-gold hover:bg-gold/10 hover:shadow-[0_0_36px_rgba(255,159,28,0.24)]';
  return <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${styles} ${className}`} animate={pulse ? {
    scale: [1, 1.035, 1]
  } : undefined} transition={pulse ? {
    duration: 1.8,
    repeat: Infinity,
    ease: 'easeInOut'
  } : undefined} whileHover={{
    scale: 1.015
  }} data-id="element-14" data-mp="19aptmvbruefr">
      <span className="text-center" data-id="element-15" data-mp="1s7qxudxi4ain">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-16" data-mp="1s6zec1h6i38q" />
    </motion.a>;
}